import React from 'react';

const Center = ({ children }) => (
  <div className="h-screen w-screen flex items-center justify-center">{children}</div>
);

export default Center;
